import { endpoints } from "../Constants";
import { api, cancelTokenSource } from "..";

export const getAffectedPoducts = (token: string) => api.get(endpoints.MY_PRODUCTS_AFFECTED, { 
    headers: {
        Authorization: `Bearer ${token}`
    }, 
    cancelToken: cancelTokenSource.token 
})